/*
 *  Copyright (c) 2011-2024 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Modal')
    .factory('confirmAction', ['$modal', '$q', function ($modal, $q) {
        return function ($scope, attrs) {
            const modalInstance = $modal.open({
                domOptions: {
                    modalType: 'confirm',
                    modalTitle: attrs.confirmTitle,
                    modalActionButton: attrs.confirmSubmit,
                    modalCancelButton: attrs.confirmCancel,
                    modalBodyTemplate: attrs.confirmBodyTemplate || 'modals/actions/confirm',
                    modalBodyText: attrs.confirmBody,
                    modalAction: 'confirm'
                },
                controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                    $scope.modal = $modalInstance.options;
                    $scope.modal.actionButtonClass = attrs.confirmSubmitClass;

                    if (angular.isFunction(attrs.onOpen)) {
                        $modalInstance.opened.then(attrs.onOpen);
                    }

                    $scope.ok = function () {
                        $q.resolve()
                            .then(function () {
                                if (angular.isFunction(attrs.onConfirm)) {
                                    return attrs.onConfirm();
                                } else {
                                    return true;
                                }
                            })
                            .finally(function () {
                                $modalInstance.close('ok');
                            })
                    };

                    $scope.cancel = function () {
                        $modalInstance.dismiss('cancel');
                    };

                    $scope.close = $scope.cancel;

                    if (angular.isFunction(attrs.modalUpdate)) {
                        attrs.modalUpdate($scope);
                    }
                }],
                windowClass: 'confirmation-dialog',
                size: attrs.confirmSize || '',
                backdrop: 'static',
                keyboard: false
            });

            return modalInstance.result;
        }
    }]);
